// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/app/v1/app_entitlement_user_binding_reasons.proto" (package "c1.api.app.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { MessageType } from "@protobuf-ts/runtime";
import { Timestamp } from "../../../../google/protobuf/timestamp";
/**
 * @generated from protobuf message c1.api.app.v1.GrantReason
 */
export interface GrantReason {
    /**
     * The ID of the app that is associated with the grant reason.
     *
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * The ID of the app entitlement that is associated with the grant reason.
     *
     * @generated from protobuf field: string app_entitlement_id = 2;
     */
    appEntitlementId: string;
    /**
     * The ID of the app user that is associated with the grant reason.
     *
     * @generated from protobuf field: string app_user_id = 3;
     */
    appUserId: string;
    /**
     * This is one part of the derived ID, indicating the type, like "ticket" or "group"
     *
     * @generated from protobuf field: string derived_id_type = 4;
     */
    derivedIdType: string;
    /**
     * This is the other part of the derived ID which include the details like ticket_id, group_id, etc. This provides the uniqueness.
     *
     * @generated from protobuf field: string derived_id_data = 5;
     */
    derivedIdData: string;
    /**
     * GrantReasonReferenceStrength is used to indicate the strength of the reference to the reason.
     * This is used to determine if a grant should be removed when all strong reasons are removed.
     *
     * @generated from protobuf field: c1.api.app.v1.GrantReasonReferenceStrength reference_strength = 7;
     */
    referenceStrength: GrantReasonReferenceStrength;
    /**
     * The datetime, in RFC3339 format, of when the GrantReason was created.
     *
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 8;
     */
    createdAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the GrantReason was updated.
     *
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 9;
     */
    updatedAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the GrantReason was deleted.
     *
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 10;
     */
    deletedAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the GrantReason will expire. After this timestamp it's no longer valid.
     *
     * @generated from protobuf field: google.protobuf.Timestamp reason_expires_at = 11;
     */
    reasonExpiresAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.app.v1.GrantReasonWaitingForAppUser
 */
export interface GrantReasonWaitingForAppUser {
    /**
     * @generated from protobuf field: string tenant_id = 1;
     */
    tenantId: string;
    /**
     * @generated from protobuf field: string user_id = 2;
     */
    userId: string;
    /**
     * @generated from protobuf field: string ticket_id = 3;
     */
    ticketId: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.GrantReason reason_needs_app_user = 4;
     */
    reasonNeedsAppUser?: GrantReason;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 5;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 6;
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 7;
     */
    deletedAt?: Timestamp;
}
/**
 * @generated from protobuf enum c1.api.app.v1.GrantReasonReferenceStrength
 */
export enum GrantReasonReferenceStrength {
    /**
     * @generated from protobuf enum value: GRANT_REASON_REFERENCE_STRENGTH_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: GRANT_REASON_REFERENCE_STRENGTH_WEAK = 1;
     */
    WEAK = 1,
    /**
     * @generated from protobuf enum value: GRANT_REASON_REFERENCE_STRENGTH_STRONG = 2;
     */
    STRONG = 2
}
// @generated message type with reflection information, may provide speed optimized methods
class GrantReason$Type extends MessageType<GrantReason> {
    constructor() {
        super("c1.api.app.v1.GrantReason", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "derived_id_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "derived_id_data", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "reference_strength", kind: "enum", T: () => ["c1.api.app.v1.GrantReasonReferenceStrength", GrantReasonReferenceStrength, "GRANT_REASON_REFERENCE_STRENGTH_"] },
            { no: 8, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 9, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 10, name: "deleted_at", kind: "message", T: () => Timestamp },
            { no: 11, name: "reason_expires_at", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.GrantReason
 */
export const GrantReason = new GrantReason$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GrantReasonWaitingForAppUser$Type extends MessageType<GrantReasonWaitingForAppUser> {
    constructor() {
        super("c1.api.app.v1.GrantReasonWaitingForAppUser", [
            { no: 1, name: "tenant_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "ticket_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "reason_needs_app_user", kind: "message", T: () => GrantReason },
            { no: 5, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 6, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 7, name: "deleted_at", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.GrantReasonWaitingForAppUser
 */
export const GrantReasonWaitingForAppUser = new GrantReasonWaitingForAppUser$Type();
